<template>
  <CustomPicker
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :closeOnSelect="true"
    title="title"
    :inputLabel="inputLabel"
    v-model="selectedMatchSetting"
    :items="matchSettingsList"
  >
    <template #labelOption="data">
      {{ data.item.title }} ({{ data.item.totalMatchQuestionsCount }} سوال)
    </template>
  </CustomPicker>
</template>

<script>
export default {
  emits: ["getMatchSetting"],
  props: {
    defaultSelectedMatchSetting: {
      type: Array,
      required: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: "تنظیمات مورد نظر را انتخاب کنید",
    },
  },
  watch: {
    defaultSelectedMatchSetting: {
      handler(val) {
        if (val) {
          this.selectedMatchSetting = val;
        }
      },
      immediate: true,
    },
    selectedMatchSetting: {
      handler(val) {
        this.$emit("getMatchSetting", val);
      },
    },
  },
  mounted() {
    this.getAllMatchSettings();
  },
  data() {
    return {
      isLoading: false,
      matchSettingsList: null,
      totalCount: null,
      selectedMatchSetting: null,
      matchListFilters: {
        count: 30,
        pageNumber: 1,
      },
    };
  },
  methods: {
    async getAllMatchSettings() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllMatchSettings = new GetAllMatchSettings(_this);
        getAllMatchSettings.setRequestParam(_this.matchListFilters);
        await getAllMatchSettings.fetch((res) => {
          _this.matchSettingsList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllMatchSettings } from "@/libs/Api/Matches";
</script>
